<div class="content-heading">
  <div class="header-container">
    <h3>Reporte de Inventarios</h3>
    <small>Reporte Web</small>
  </div>
</div>

<div class="container-fluid">
  <div class="card card-default shadow-sm border-0">
    <div class="card-body">
      
      <div class="row align-items-end">
        <div class="col-lg-3 col-md-6 mb-3">
          <span>Organizaci&oacute;n</span>
          <select class="form-control" [(ngModel)]="organizationSelected" 
                  name="orgSelect" [disabled]="working" (change)="getRegion()">
            <option *ngFor="let unit of organizacionList" [value]="unit.UnitId">
              {{unit.UnitDescription}}
            </option>
          </select>
        </div>

        <div class="col-lg-3 col-md-6 mb-3">
          <span>Clasificaci&oacute;n Nodo</span>
          <select class="form-control" [(ngModel)]="clasificationSelected"
                  name="clasifSelect" [disabled]="working" (change)="getNodeByRegionLevel()">
            <option [value]="1">Planta</option>
            <option [value]="2" [hidden]="user.Org === 2">Ceve</option>
          </select>
        </div>

        <div class="col-lg-3 col-md-6 mb-3">
          <span>Nodo</span>
          <ng-autocomplete
            [placeholder]="'Búsqueda'"
            [disabled]="working"
            [data]="unitList"
            [searchKeyword]="'UnitDescription'"
            [itemTemplate]="itemTemplate"
            [notFoundTemplate]="notFoundTemplate"
            [debounceTime]="600"
            [minQueryLength]="3"
            [(ngModel)]="unitSelected">
          </ng-autocomplete>

          <ng-template #itemTemplate let-item>
            <a [innerHTML]="item.UnitDescription"></a>
          </ng-template>
          <ng-template #notFoundTemplate let-notFound>
            <div [innerHTML]="'No se encontraron coincidencias'"></div>
          </ng-template>
        </div>

        <div class="col-lg-3 col-md-6 mb-3">
          <aph-custom-date-picker 
            [singleMode]="true" 
            labelInicio="Fecha de Inventario"
            [maxDate]="today"
            mode="date"
            [IsDisabledAll]="working"
            (startDateChange)="selectedDate = $event"
            (onValidationStatus)="esValido = $event">
          </aph-custom-date-picker>
        </div>
      </div>

      <hr class="my-4">

      <div class="row">
        <div class="col-12">
          <aph-custom-buttons 
            preset="excel" 
            [label]="downloading ? 'Descargando' : 'Descargar reporte'" 
            [loading]="downloading"
            [disabled]="downloading || !esValido" 
            (btnClick)="download()">
          </aph-custom-buttons>
        </div>
      </div>

    </div>
  </div>
</div>